import { Injectable } from '@angular/core';
import { AnimationController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class AnimationService {
  constructor(private animationCtrl: AnimationController) {}

  fadeIn = (el: Element | Node | Element[] | Node[] | NodeList) => this.animationCtrl.create().addElement(el).to('opacity', 1).duration(ANIMATION_DURATION);

  fadeOut = (el: Element | Node | Element[] | Node[] | NodeList) => this.animationCtrl.create().addElement(el).to('opacity', 0).duration(ANIMATION_DURATION);
}

export const ANIMATION_DURATION = 150;
